import { Box, Heading, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { CreditAgreementsOverviewTable } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreementOverviewTable';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

export const CreditAgreementsOverview = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const { user } = useUserAuthOrThrow();

  let routeLevelError = false;
  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to credit agreements overview page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <Heading as="h2">Credit Agreements Overview</Heading>
        <CreditAgreementsOverviewTable organizationId={user.organizationId} />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
